import { lazy } from "react";

const RELOAD_KEY = "moltech_chunk_reload";

const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading chunk .+ failed/i.test(String(error?.message || ""));

export const lazyWithRetry = (importer) =>
  lazy(async () => {
    try {
      const mod = await importer();
      sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (error) {
      if (isChunkLoadError(error) && !sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, "1");
        window.location.reload();
        return new Promise(() => {});
      }
      sessionStorage.removeItem(RELOAD_KEY);
      throw error;
    }
  });
